import Graph from './components/index';

export default Graph;



// WEBPACK FOOTER //
// ./src/lib/index.js